__turbopack_context__.v({
  "item": "Schedule-module__VjCL7q__item",
  "list": "Schedule-module__VjCL7q__list",
  "meetingTimes": "Schedule-module__VjCL7q__meetingTimes",
  "section": "Schedule-module__VjCL7q__section",
});
